// extracted by mini-css-extract-plugin
export default {"news_list":"index_news_list_BQZ-0","box":"index_box_Z-kV5","list":"index_list_Lou95"};